import React, { useState } from 'react';
import useLinksData from '../../../hooks/useLinksData';

// `redirectOnClose` permite reutilizar este modal para avisar de un error:
// en ese caso el usuario debe quedarse en la cotización para reintentar,
// no irse a la página de agradecimiento.
const ModalCustomMessageBody = ({title, message, textButton, onCloseModal, redirectOnClose = true}) => {
    const { getBasename } = useLinksData();
    const basename = getBasename();

    const goToThankYouPage = () => {
        // Usar el basename del contexto
        const baseUrl = basename || '/';
        window.location.href = `${baseUrl}/gracias`;
    };

    const handleCloseModal = () => {
        // Llamar primero al onCloseModal original para cerrar el modal
        if (onCloseModal) {
            onCloseModal(true);
        }
        // Luego redirigir a la página de agradecimiento
        if (redirectOnClose) {
            goToThankYouPage();
        }
    };

    return (
        <div className="modal-box">
            {/* <div className="close-button icon close" id="close-modal" onClick={onCloseModal}></div> */}
            <div className="modal-body">
                <h3>{title}</h3>
                <p>{message}</p>
                <div className="buttons-container">
                    <a className="btn black" onClick={handleCloseModal}>{textButton}</a>
                </div>
            </div>
        </div>
    )
}

export default ModalCustomMessageBody;